import { PropsWithChildren } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

export const DragAndDrop = ({ children, touch }: PropsWithChildren<{ touch?: boolean }>): JSX.Element => (
  <DndProvider backend={touch ? TouchBackend : HTML5Backend}>{children}</DndProvider>
);
